import { createAsyncThunk } from "@reduxjs/toolkit";
import { DocumentService } from "../../../api";

export const getPage = createAsyncThunk("srPdf/getPage", ({ docId, page, token }) =>
  DocumentService.getPage({ docId }, { page }, token)
);
